<div *ngIf="form">
  <form [formGroup]="form">
    <div class="flex flex-col mt-3">
      <div class="my-3">
        <dx-text-box mode="password"
                     formField
                     formControlName="password"
                     [label]="'common.password' | translate | ucfirst"
                     required
                     minlength="6"
                     pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{6,}$"
                     [attr.data-pattern-msg]="'errors.userPassword' | translate"
        />
        <dx-text-box mode="password"
                     formField
                     formControlName="confirmPassword"
                     [label]="'common.confirmPassword' | translate | ucfirst"
        />
        <div class="dx-datagrid-edit-popup" *ngIf="form.controls['password'].touched && form.controls['confirmPassword'].touched && form.hasError('notSame')">
          <div class="dx-error-message">{{ 'errors.notSame' | translate:{field: 'password'} }}</div>
        </div>
      </div>
      <div class="content-center mb-3">
        <div class="items-center justify-center">
          <dx-button [text]="'common.send' | translate" style="color: white;"
            type="default"
            [disabled]="form.invalid"
            (click)="resetPassword()"
          ></dx-button>
        </div>
      </div>
    </div>
  </form>
</div>
